export { Link } from './Link'



// WEBPACK FOOTER //
// ./src/views/components/Link/index.tsx